export default "__VITE_ASSET__DewS99qK__"